import { Button } from '@/components/Button';

export function PrivacyPage() {
  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4">
        <h1 className="text-lg font-semibold text-foreground">Privacy</h1>
        <p className="text-sm text-foreground-muted">Manage your privacy and data preferences</p>
      </div>

      {/* Form */}
      <div className="max-w-2xl space-y-6">
        {/* Data Collection */}
        <div className="rounded border border-border bg-background-subtle p-4">
          <h3 className="text-sm font-medium text-foreground mb-3">Data Collection</h3>
          <div className="space-y-3">
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" defaultChecked className="rounded border-border" />
              <span className="text-sm text-foreground">Allow usage analytics</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input type="checkbox" className="rounded border-border" />
              <span className="text-sm text-foreground">Share anonymous usage data to improve the product</span>
            </label>
          </div>
        </div>

        {/* Profile Visibility */}
        <div className="rounded border border-border bg-background-subtle p-4">
          <label className="block text-sm font-medium text-foreground mb-2">Profile Visibility</label>
          <select className="w-full rounded border border-border bg-background px-3 py-2 text-sm text-foreground focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary">
            <option>Workspace members only</option>
            <option>Public</option>
            <option>Private</option>
          </select>
          <p className="mt-2 text-xs text-foreground-muted">Control who can see your profile information</p>
        </div>

        {/* Data Export */}
        <div className="rounded border border-border bg-background-subtle p-4">
          <h3 className="text-sm font-medium text-foreground mb-2">Data Export</h3>
          <p className="text-sm text-foreground-muted mb-3">Download all your personal data and activity</p>
          <Button size="sm" variant="secondary">Request Data Export</Button>
        </div>

        {/* Account Deletion */}
        <div className="rounded border border-border-error bg-error/5 p-4">
          <h3 className="text-sm font-medium text-error mb-2">Delete Account</h3>
          <p className="text-sm text-foreground-muted mb-3">Permanently delete your account and all associated data</p>
          <Button size="sm" variant="secondary">Delete My Account</Button>
        </div>

        {/* Save Button */}
        <div className="flex justify-end gap-2">
          <Button variant="secondary">Cancel</Button>
          <Button variant="primary">Save Changes</Button>
        </div>
      </div>
    </div>
  );
}
